// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const RoleNameBlankModal = observer(() => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`Role name cannot be blank`}
			description={t`You cannot save a role with a blank name. Please provide a valid name before saving.`}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
